import { render, staticRenderFns } from "./TemperatureSaveDialog.vue?vue&type=template&id=c04cb64e&scoped=true&"
import script from "./TemperatureSaveDialog.vue?vue&type=script&lang=js&"
export * from "./TemperatureSaveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04cb64e",
  null
  
)

export default component.exports